// extracted by mini-css-extract-plugin
module.exports = {"platformInfo":"platform-list-header_platformInfo__3kfkd","title":"platform-list-header_title__12TEW","link":"platform-list-header_link__12EOB"};